<template>
	<div :class="['quaterly-item', mode === 'overview' ? 'overview' : 'normal']">
		<div>
			<div class="quarter">Q{{ item.quarter }}</div>
			<div class="year"  v-if="mode === 'overview'">{{ item.performanceYear }}</div>
		</div>
		<div class="performance-list">
			<!-- 业绩公告 -->
			<div class="performance-item" @click="itemHandler('announcementLink', item)">
				<span class="performance-item-title">{{ $t('enterprise.results-announcement') }}</span>
				<span class="type-icon">{{ handleFileType(item.announcementLink) }}</span>
			</div>
			<!-- 业绩摘要 -->
			<div class="performance-item" v-if="item.roundupTitle" @click="itemHandler('roundupLink', item)">
				<span class="performance-item-title">{{ $t('enterprise.results-summary') }}</span>
				<span class="type-icon">{{ handleFileType(item.roundupLink) }}</span>
			</div>
			<!--演示材料  -->
			<div class="performance-item" v-if="item.showTitle" @click="itemHandler('showLink', item)">
				<span class="performance-item-title">{{ $t('enterprise.earnings-library') }}</span>
				<span class="type-icon">{{ handleFileType(item.showLink) }}</span>
			</div>
			<!-- 业绩路演 -->
			<div class="performance-item" v-if="item.roadshowId" @click="itemHandler('roadshowLink', item)">
				<span class="performance-item-title">{{ $t('enterprise.earnings-calls') }}</span>
				<span class="type-icon">HTML</span>
			</div>
			<!-- 一图读懂 -->
			<div class="performance-item" v-if="item.longImage" @click="itemHandler('imageLink', item)">
				<span class="performance-item-title">{{ $t('enterprise.page-version') }}</span>
				<span class="type-icon">{{ handleFileType(item.longImage) }}</span>
			</div>
		</div>
	</div>
</template>

<script setup>
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';

defineProps({
	item: {
		type: Object,
		required: true
	},
	mode: {
		type: String,
		default: 'overview'
	}
});

const { viewModule } = useModuleNavigation();
const itemHandler = (type, item) => {
	const { announcementLink, roundupLink, showLink, roadshowLink, id, longImage } = item;
	if (type === 'announcementLink') {
		viewModule('quarterly_performance_announcement', { comeinLink: announcementLink, id });
	} else if (type === 'roundupLink') {
		viewModule('quarterly_performance_summary', { comeinLink: roundupLink, id });
	} else if (type === 'showLink') {
		viewModule('quarterly_performance_custom', { comeinLink: showLink, id });
	} else if (type === 'roadshowLink') {
		viewModule('quarterly_performance_roadshow', { roadshowLink, id });
	} else if (type === 'imageLink') {
		viewModule('quarterly_performance_image_preview', { url: longImage });
	}
};

const handleFileType = (url) => {
	const fileType = url.split('.').pop().toUpperCase();
	return fileType
};
</script>

<style lang="less" scoped>
.quaterly-item {
	height: 100%;
	border-radius: 8px;
	background: var(--surf-secondary-color);
}
.overview {
	position: relative;
	padding: 40px;
	width:488px;
	min-height: 420px;  // 最小预留三个字段的高度

	.quarter {
		padding: 44px 0 40px;
		color: var(--surf-inverse-color);
		font-size: 56px;
		font-weight: 400;
		line-height: 48px; /* 85.714% */
	}
	.year {
		position: absolute;
		top: 40px;
		right: 40px;
		color: rgba(var(--surf-inverse-color-rgb), 0.1);
		font-size: 64px;
		font-weight: 600;
		line-height: 72px; /* 112.5% */
	}
	.performance-list {
		display: flex;
		flex-direction: column;
		.performance-item {
			padding: 16px 0;
			display: flex;
			justify-content: space-between;
			align-items: center;
			cursor: pointer;
			&:not(:last-child) {
				border-bottom: 1px solid rgba(var(--surf-inverse-color-rgb), 0.15);
			}
			.type-icon {
				color: #3964e5;
				font-size: 20px;
				font-weight: 400;
				line-height: 28px; /* 140% */
			}
			.performance-item-title {
				color: var(--surf-inverse-color);
				font-size: 24px;
				font-weight: 400;
				line-height: 32px;
			}
		}
	}
}

.normal {
	padding: 12px;
	.quarter {
		color: var(--surf-inverse-color);
		font-size: 24px;
		font-weight: 400;
		line-height: 32px; /* 133.333% */
        text-align: right;
	}
    .performance-list {
		display: flex;
		flex-direction: column;
		.performance-item {
			padding: 8px 0;
			display: flex;
			justify-content: space-between;
			align-items: center;
			cursor: pointer;
			&:not(:last-child) {
				border-bottom: 1px solid rgba(var(--surf-inverse-color-rgb), 0.15);
			}
			.type-icon {
				color: #3964e5;
				font-size: 12px;
				font-weight: 400;
				line-height: 16px; /* 140% */
			}
			.performance-item-title {
				color: var(--surf-inverse-color);
				font-size: 14px;
                font-weight: 400;
                line-height: 18px; /* 128.571% */
			}
		}
	}
}

.mobile.overview, .mobile.normal {
	padding: 12px;
	width: auto;
	height: 236px; 
	min-height: auto!important;
	.quarter {
		padding: 20px 0 10px;
		font-size: 28px;
		line-height: 24px;
	}
	.year {
		top: 12px;
		right:12px;
		font-size: 24px;
		line-height: 28px;
	}
	.performance-item {
		padding: 6px 0;
	}
	.performance-item-title{
		font-size: 15px!important;
		line-height: 20px!important;
	}
	.type-icon {
		font-size: 15px!important;
		line-height: 12px!important;
	}
}
.mobile.normal {
	.quarter {
	  padding: 0 0 10px 0;
	}
}
</style>
